export type SignupLocale = "it" | "en";

/** The part of `Navigator` the rule reads; a parameter so tests can pass any browser. */
type LanguageSource = Partial<Pick<Navigator, "language" | "languages">>;

function browserNavigator(): LanguageSource | undefined {
  return typeof navigator === "undefined" ? undefined : navigator;
}

/**
 * Pick the signup page locale from the browser. The page is rendered
 * pre-tenant (no signed-in user, no tenant settings to read a preference
 * from), so the browser's own language is the only signal available.
 * The market is Italian (C-123): English only when the browser language
 * starts with "en", Italian for every other language and when there is none.
 * The browser language is `navigator.language`, or the first of
 * `navigator.languages` when that is empty. The result is also the `locale`
 * sent to `/api/signup/start`, which picks the code email's language.
 */
export function detectLocale(nav: LanguageSource | undefined = browserNavigator()): SignupLocale {
  const language = nav?.language || nav?.languages?.[0] || "";
  return language.toLowerCase().startsWith("en") ? "en" : "it";
}
